const pageID = {
    page_id: "",
    page_type: "",
    page_route: "",
    page_alias: "",
    page_name: "",
    component_id: "",
    component_template_id: "",
    page_title: "",
    page_previous: "",
};
const environmentData = {
    env_country_code: "",
    env_language_code: "",
    env_version_number: "",
    env_realm: "",
    env_platform: "",
    env_login_status: "",
    env_brand: "",
};
const auth = {
    user_profile_id: "",
    auth_login_status: "",
};
const favourite = {
    favourite_action: "",
    item_type: "",
    item_id: "",
    item_name: "",
};
const contentImpression = {
    product_id: "",
    content_primary_channel: "",
    content_alternate_id: "",
    content_analytics_id: "",
    content_show: "",
    content_type: "",
};
const click = {
    parent_title: "",
    parent_position: 0,
    child_title: "",
    child_position: 0,
};
const adImpression = {
    customer_id: "",
    ad_id: "",
    ad_name: "",
    ad_length: 0,
    ad_position: "",
};
export var BlueShiftEvents;
(function (BlueShiftEvents) {
    BlueShiftEvents["PAGE_LOADED"] = "page_view";
    BlueShiftEvents["AUTHENTICATION"] = "auth";
    BlueShiftEvents["ENVIRONMENT"] = "init";
    BlueShiftEvents["FAVORITE"] = "favourite";
    BlueShiftEvents["CONTENT_IMPRESSION"] = "content_impression";
    BlueShiftEvents["CLICK"] = "click";
    BlueShiftEvents["AD_IMPRESSION"] = "ad_impression";
})(BlueShiftEvents || (BlueShiftEvents = {}));
